export const plan = [

    {
        title: "Basic Plan",
        price: "30.99",
        storage: "5GB File Storage",
        bandwidth: "40GB Super Bandwidth",
        database: "5 SQL Database Storage",
        email_account: "3 Email Account Free",
        technical_support: "24/7 Technical Support"

    },
    {
        title: "Professional plan",
        price: "50.99",
        storage: "15GB File Storage",
        bandwidth: "140GB Super Bandwidth",
        database: "15 SQL Database Storage",
        email_account: "13 Email Account Free",
        technical_support: "24/7 Technical Support"

    },
    {
        title: "Standard plan",
        price: "80.99",
        storage: "50GB File Storage",
        bandwidth: "200GB Super Bandwidth",
        database: "20 SQL Database Storage",
        email_account: "15 Email Account Free",
        technical_support: "24/7 Technical Support"

    },
]